export class HeadingComponent {
    public static SELECTOR: string = ".js-ina-heading";

    private _currentContext: JQuery<HTMLElement> = $();
    private _currentHtml: string;

    public setHtml(html: string): HeadingComponent {
        this._currentHtml = html;
        return this;
    }

    public getHtml(): string {
        return this._currentHtml;
    }

    public render(): void {
        this._currentContext.html(this._currentHtml);
    }

    public initContext(): void {
        this._currentHtml = this._currentContext.html();
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.initContext();
    }
}
